import {Drawer, Layout, Menu} from "antd";
import {Link, useLocation} from "react-router-dom";
import {useState, useMemo} from "react";
import {useDashboardDataContext} from "../../context/dashboardDataContext";
import logo from "@/assets/image/logo_tersu.png";
import {AiOutlineControl} from "react-icons/ai";
import {CiCircleList} from "react-icons/ci";
import {MdFormatListBulletedAdd} from "react-icons/md";
import {MdOutlineAddTask} from "react-icons/md";
import {RxDashboard} from "react-icons/rx";
import {LuUsers} from "react-icons/lu";
import {AiOutlineBarChart, AiOutlinePlusCircle } from "react-icons/ai";
import {AiOutlineDashboard} from "react-icons/ai";
import {AiOutlineUser} from "react-icons/ai";
import {AiOutlineCalendar} from "react-icons/ai";
import {MdEventNote} from "react-icons/md";
import {MdRateReview} from "react-icons/md";
import {MdOutlineRateReview} from "react-icons/md";
import {BsListCheck} from "react-icons/bs";
import {MdOutlinePlaylistAdd} from "react-icons/md";
import {IoNotificationsOutline} from "react-icons/io5";
import {IoSettingsOutline} from "react-icons/io5";
import {IoSendOutline} from "react-icons/io5";
import {getAccessToken} from "../../utils/tokenCookies";
import getUserRoles from "../../utils/jwtDecode";

const {Sider} = Layout;
const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: 'thin',
    scrollbarGutter: 'stable',
};
const Sidebar = () => {
    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const {sidebarMini, setSidebarMini, isMobile} = useDashboardDataContext();

    const token = getAccessToken();
    const roles = getUserRoles(token);

    const navItems = useMemo(() => [
        {
            key: "group0",
            label: !sidebarMini ? <span style={{fontWeight: 600}}>Boshqaruv paneli</span> : null,
            type: "group",
            children: [
                {
                    key: "/",
                    icon: <RxDashboard size={20}/>,
                    label: (
                        <Link to="/">
                            <span style={{fontWeight: location.pathname === "/" ? 500 : 400}}>
                                Boshqaruv paneli
                            </span>
                        </Link>
                    ),
                },
                // {
                //     key: "/dashboard/user",
                //     icon: <AiOutlineUser size={19} />,
                //     label: (
                //         <Link to="/dashboard/user">
                //             <span style={{ fontWeight: location.pathname === "/dashboard/user" ? 500 : 400 }}>
                //                 Shaxsiy Dashboard
                //             </span>
                //         </Link>
                //     ),
                // },
            ],
        },
        {
            key: "group1",
            label: !sidebarMini ? <span style={{fontWeight: 600}}>Topshiriqlar</span> : null,
            type: "group",
            children: [
                {
                    key: "/tasks/create",
                    icon: <AiOutlinePlusCircle  size={25} />,
                    label: (
                        <Link to="/tasks/create">
                            <span style={{fontWeight: location.pathname === "/tasks/create" ? 500 : 400}}>
                                Topshiriq yaratish
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/tasks/list",
                    icon: <CiCircleList size={25}/>,
                    label: (
                        <Link to="/tasks/list">
                            <span style={{fontWeight: location.pathname === "/tasks/list" ? 500 : 400}}>
                                Topshiriqlar ro‘yxati
                            </span>
                        </Link>
                    ),
                },

                {
                    key: "/my-tasks/list",
                    icon: <MdOutlineAddTask size={24}/>,
                    label: (
                        <Link to="/my-tasks/list">
                            <span
                                style={{fontWeight: location.pathname === "/my-tasks/list" ? 500 : 400, fontSize: 14}}>
                              Yuborilgan topshiriqlar
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/tasks/review",
                    icon: <MdRateReview size={23}/>,
                    label: (
                        <Link to="/tasks/review">
                            <span style={{fontWeight: location.pathname === "/tasks/review" ? 500 : 400, fontSize: 14}}>
                                Baholash uchun
                            </span>
                        </Link>
                    ),
                    visible: roles.includes("superadmin") || roles.includes("reviewer"),
                },
                {
                    key: "/my-reviews",
                    icon: <MdOutlineRateReview size={23}/>,
                    label: (
                        <Link to="/my-reviews">
                            <span style={{fontWeight: location.pathname === "/my-reviews" ? 500 : 400, fontSize: 14}}>
                                Mening baholarim
                            </span>
                        </Link>
                    ),
                },
            ],
        },
        {
            key: "group1.5",
            label: !sidebarMini ? <span style={{fontWeight: 600}}>Kunlik vazifalar</span> : null,
            type: "group",
            children: [
                {
                    key: "/daily-todos/today",
                    icon: <BsListCheck size={23}/>,
                    label: (
                        <Link to="/daily-todos/today">
                            <span style={{fontWeight: location.pathname === "/daily-todos/today" ? 500 : 400, fontSize: 14}}>
                                Bugungi vazifalar
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/admin/daily-todos/create",
                    icon: <MdOutlinePlaylistAdd size={25}/>,
                    label: (
                        <Link to="/admin/daily-todos/create">
                            <span style={{fontWeight: location.pathname === "/admin/daily-todos/create" ? 500 : 400, fontSize: 14}}>
                                Vazifalar yaratish
                            </span>
                        </Link>
                    ),
                    visible: roles.includes("superadmin"),
                },
            ],
        },
        {
            key: "group2",
            label: !sidebarMini ? <span style={{fontWeight: 600}}>Tadbirlar</span> : null,
            type: "group",
            children: [
                {
                    key: "/events",
                    icon: <MdEventNote size={20}/>,
                    label: (
                        <Link to="/events">
                            <span style={{fontWeight: location.pathname === "/events" ? 500 : 400}}>
                                Mening tadbirlarim
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/events/all",
                    icon: <AiOutlineCalendar size={20}/>,
                    label: (
                        <Link to="/events/all">
                            <span style={{fontWeight: location.pathname === "/events/all" ? 500 : 400}}>
                                Barcha tadbirlar
                            </span>
                        </Link>
                    ),
                    visible: roles.includes("admin") || roles.includes("superadmin"),
                },
            ],
        },
        {
            key: "group3",
            label: !sidebarMini ? <span style={{fontWeight: 600}}>Tizim</span> : null,
            type: "group",
            visible: roles.includes("admin") || roles.includes("superadmin"),
            children: [
                // {
                //     key: "/dashboard/admin",
                //     icon: <AiOutlineDashboard size={20} />,
                //     label: (
                //         <Link to="/dashboard/admin">
                //             <span style={{ fontWeight: location.pathname === "/dashboard/admin" ? 500 : 400 }}>
                //                 Admin Dashboard
                //             </span>
                //         </Link>
                //     ),
                // },
                {
                    key: "/analytics",
                    icon: <AiOutlineBarChart size={25}/>,
                    label: (
                        <Link to="/analytics">
                            <span style={{fontWeight: location.pathname === "/analytics" ? 500 : 400}}>
                                Analitika
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/created/tasks/all",
                    icon: <MdFormatListBulletedAdd size={25}/>,

                    label: (
                        <Link to="/created/tasks/all">
                            <span style={{fontWeight: location.pathname === "/created/tasks/all" ? 500 : 400}}>
                                Yaratilgan topshiriqlar
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/roles",
                    icon: <AiOutlineControl size={25}/>,

                    label: (
                        <Link to="/roles">
                            <span style={{fontWeight: location.pathname === "/roles" ? 500 : 400}}>
                                Tizim rollar
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/users",
                    icon: <LuUsers size={25}/>,
                    label: (
                        <Link to="/users">
                            <span style={{fontWeight: location.pathname === "/users" ? 500 : 400}}>
                                Foydalanuvchilar
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/admin/notifications",
                    icon: <IoNotificationsOutline size={25}/>,
                    label: (
                        <Link to="/admin/notifications">
                            <span style={{fontWeight: location.pathname === "/admin/notifications" ? 500 : 400}}>
                                Bildirishnomalar
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/admin/notifications/settings",
                    icon: <IoSettingsOutline size={25}/>,
                    label: (
                        <Link to="/admin/notifications/settings">
                            <span style={{fontWeight: location.pathname === "/admin/notifications/settings" ? 500 : 400}}>
                                Bildirishnoma sozlamalari
                            </span>
                        </Link>
                    ),
                },
                {
                    key: "/admin/notifications/test",
                    icon: <IoSendOutline size={25}/>,
                    label: (
                        <Link to="/admin/notifications/test">
                            <span style={{fontWeight: location.pathname === "/admin/notifications/test" ? 500 : 400}}>
                                Test bildirishnoma
                            </span>
                        </Link>
                    ),
                },
            ],
        },
    ], [sidebarMini, location.pathname, roles]);

    // Filter menu items based on visibility
    const filteredNavItems = useMemo(() => {
        return navItems
            .filter((item) => item.visible ?? true)
            .map((item) => {
                if (item.children) {
                    // Remove 'visible' prop from children to avoid React warning
                    const filteredChildren = item.children
                        .filter((child) => child.visible ?? true)
                        .map(({ visible, ...rest }) => rest);

                    // Remove 'visible' prop from parent item as well
                    const { visible, ...itemRest } = item;
                    return {
                        ...itemRest,
                        children: filteredChildren,
                    };
                }
                // Remove 'visible' prop from items without children
                const { visible, ...itemRest } = item;
                return itemRest;
            });
    }, [navItems]);

    if (isMobile) {
        return (
            <Drawer
                open={sidebarMini}
                placement="left"
                onClose={() => setSidebarMini(false)}
                styles={{ body: { padding: 0 } }}
                width={250}
            >
                {/* Logo qismi */}
                <Link

                    to="/"
                    onClick={() => setSidebarMini(false)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: "16px",
                        borderBottom: "1px solid #f0f0f0",
                    }}
                >
                    <div
                        style={{
                            display: "grid",
                            placeItems: "center",
                            borderRadius: "12px",
                            padding: "6px",
                            // background: "linear-gradient(to bottom right, #ecfdf5, #e0f2fe)",
                            // border: "1px solid #a7f3d0",
                            flexShrink: 0,
                        }}
                    >
                        <img
                            src={logo}
                            alt="Logo"
                            style={{height: 43, width: 43, objectFit: "contain"}}
                        />
                    </div>
                    <div style={{lineHeight: "1.2"}}>
                        <div
                            style={{
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#1e293b",
                            }}
                        >
                            Termiz davlat universiteti
                        </div>
                        <span style={{fontSize: "12px", color: "#64748b", fontWeight: 500}}>
                            Ijro nazorati
                        </span>
                    </div>
                </Link>

                {/* Menu */}
                <Menu
                    theme="light"
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    items={filteredNavItems}
                    onClick={() => setSidebarMini(false)}
                />
            </Drawer>
        );
    }

    return (
        <Sider
            width={280}
            collapsible
            collapsed={sidebarMini}
            onCollapse={setCollapsed}
            theme="dark"
            trigger={null}
            style={{
                position: "fixed",
                left: 0,
                top: 0,
                bottom: 0,
                zIndex: 999,
                background: "linear-gradient(180deg, #001529 0%, #000c17 100%)",
                color: "#fff",

                display: "flex",
                flexDirection: "column", // muhim! pastda scroll bo‘lishi uchun


            }}
        >
            {/* 🔹 Logo qismi */}
            <Link
                to="/"
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "16px",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                    background: "transparent",
                    flexShrink: 0, // scrollga kirmaydi
                }}
            >
                <div
                    style={{
                        display: "grid",
                        placeItems: "center",
                        borderRadius: "12px",
                        padding: "6px",
                        // background: "rgba(255,255,255,0.1)",
                        // border: "1px solid rgba(255,255,255,0.2)",
                        flexShrink: 0,
                    }}
                >
                    <img
                        src={logo}
                        alt="Logo"
                        style={{height: 43, width: 43, objectFit: "contain"}}
                    />
                </div>

                {!sidebarMini && (
                    <div style={{lineHeight: "1.2"}}>
                        <div style={{fontSize: "14px", fontWeight: 600, color: "#fff"}}>
                            Termiz davlat universiteti
                        </div>
                        <span style={{fontSize: "11px", color: "#94a3b8", fontWeight: 500}}>
          Ijro nazorati
        </span>
                    </div>
                )}
            </Link>

            {/* 🔹 Menu scroll bo‘ladigan qism */}
            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    msOverflowStyle: "none", // IE uchun
                    scrollbarWidth: "none", // Firefox uchun
                }}
                className="sidebar-menu-scroll"
            >
                <Menu
                    theme="dark"
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    items={filteredNavItems}
                    style={{
                        background: "transparent",
                        borderRight: "none",
                         overflow: 'auto',
                height: '85vh',
                 scrollbarWidth: "none", // Firefox uchun
    msOverflowStyle: "none", // IE uchun
                insetInlineStart: 0,
                    }}
                />
            </div>
        </Sider>


    );
};

export default Sidebar;
